import { h, Component } from "preact";
import cx from "classnames";
import { Subscription, Subject } from "rxjs";
import moment from "moment-timezone";
import { map, filter, distinctUntilChanged } from "rxjs/operators";

import { ModalProps, Modal } from "../../common/modal";
import { Form, FieldList, Field } from "../../../../../types/form.model";
import * as Validators from "../../../../../types/validator.model";
import {
  validateForm,
  cxValidateField,
} from "../../../../../types/validator.model";
import linkform, { updateFormFieldValue } from "../../../../utils/linkform";
import getStore, { appState$ } from "../../../store";

import {
  PurchaseDocument,
  ReceivingReport,
} from "../../../../../types/purchase-document.model";
import {
  REQUEST_IN_PROGRESS,
  REQUEST_SUCCESS,
} from "../../../../../types/request-state.model";
import { Item, ItemPiece } from "../../../../../types/item.model";
import { ItemSearch } from "../../common/item-search.component";
import { toFixed } from "../../../../utils/decimal";
import { getSpinnerBlock } from "../../common/spinner-block";
import {
  CREATE_PURCHASE_DOCUMENT,
  SIGN_PURCHASE_DOCUMENT,
  UPDATE_PURCHASE_DOCUMENT,
} from "../../../reducers/motorpool/motorpool.actions";

interface SignPDProps extends ModalProps {
  pd: PurchaseDocument;
  signAction: string;
}

interface SignPDState {
  form?: Form;
  isPostInProgress?: boolean;
}

export class SignPDModal extends Modal<SignPDProps, SignPDState> {
  form$: Subject<Form>;
  subs: Subscription[] = [];

  constructor(props: SignPDProps) {
    super(props);

    this.createForm(props);
  }

  createForm(props: SignPDProps) {
    let fields: FieldList = {
      actionBy: new Field([Validators.required], null, null),
    };

    this.form$ = new Subject<Form>();
    this.setState({
      form: new Form(fields),
    });

    this.form$.subscribe((form) => {
      validateForm(form);

      let state = {};
      state["form"] = form;
      this.setState(state);
    });
  }

  componentDidMount(): void {
    super.componentDidMount();

    const motorpool$ = appState$.pipe(map((appState) => appState.motorpool));

    this.subs.push(
      motorpool$
        .pipe(
          map((motorpool) => motorpool.postPutRequestState),
          distinctUntilChanged()
        )
        .subscribe((postPutRequestState) => {
          if (postPutRequestState === REQUEST_SUCCESS) {
            this.setState({
              isPostInProgress: false,
            });
            this.props.close();
          } else if (postPutRequestState === REQUEST_IN_PROGRESS) {
            this.setState({
              isPostInProgress: true,
            });
          }
        })
    );
  }

  doModalClose = () => {
    if (this.props.close) {
      this.props.close();
    }
  };

  onSubmit = () => {
    const form = this.state.form;
    validateForm(form);

    if (!form.isValid) {
      return;
    }

    // const restFieldName: string = getSignActionRestFieldName(
    //   this.props.signAction
    // );
    let purchaseDocumentSignPayload = {
      purchaseDocumentId: this.props.pd.purchaseDocumentId,
      signAction: this.props.signAction,
    };

    purchaseDocumentSignPayload[this.props.signAction] =
      form.fields["actionBy"].value;

    const store = getStore();
    store.dispatch({
      type: SIGN_PURCHASE_DOCUMENT,
      payload: {
        purchaseDocumentSignPayload,
      },
    });
  };

  getFormBlock(props: SignPDProps, state: SignPDState) {
    const form = this.state.form;
    const fieldName: string = getSignActionFieldName(props.signAction);

    return (
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div class="col-12 col-lg-6 mt-3">
              <label class="anglo-remittance__submit-form__label">
                {fieldName}
              </label>
              <input
                className={cx("form-control", {
                  invalid: cxValidateField(form.fields["actionBy"]),
                })}
                type="text"
                value={form.fields["actionBy"].value}
                onChange={linkform(this.form$, form, "actionBy")}
                placeholder={fieldName}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  getActionsRow(props: SignPDProps, state: SignPDState) {
    if (state.isPostInProgress) {
      return getSpinnerBlock(state.isPostInProgress);
    } else {
      return (
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-lg-3 offset-lg-9">
              <button
                class="btn btn-primary w-100"
                onClick={this.onSubmit}
                disabled={!state.form.isValid}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      );
    }
  }

  render(props: SignPDProps, state: SignPDState) {
    return (
      <div
        class="container anglo-modal create-pd-modal"
        ref={(node) => (this.refNode = node)}
      >
        <div class="row anglo-modal__head align-items-center">
          <div class="col-9 col-md-10">
            <h3 class="mb-0">
              Update Purchase Document | {props.pd.purchaseDocumentId}
            </h3>
          </div>
          <div class="col-3 col-md-2">
            <button
              class="btn btn-outline-light w-100"
              onClick={this.doModalClose}
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="row anglo-modal__body py-3">
          <div class="col-12 create-withdrawal-modal__body pb-3">
            {this.getFormBlock(props, state)}
          </div>
        </div>

        <div class="row vehicle-card__actions">
          {this.getActionsRow(props, state)}
        </div>
      </div>
    );
  }
}

export const getSignActionFieldName = (signAction: string) => {
  let fieldName: string = "";

  switch (signAction) {
    case SIGN_ACTION_NOTE:
      fieldName = "Noted By";
      break;

    case SIGN_ACTION_REQUEST_APPROVE:
      fieldName = "Request Approved By";
      break;
  }

  return fieldName;
};

export const SIGN_ACTION_NOTE: string = "notedBy";
export const SIGN_ACTION_REQUEST_APPROVE: string = "requestApprovedBy";
export const SIGN_ACTION_ORDER_APPROVED: string = "orderApprovedBy";
